<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text">Обучение</span>
      </div>
      <div>
        <v-btn
          depressed
          outlined
          color="var(--app-dark-blue-1)"
          class="button-accept"
          style="width: 229px !important"
          @click="goToAddTraining"
        >
          <span> + Добавить </span>
        </v-btn>
      </div>
    </div>
    <div v-if="loading" class="privileges-table">
      <v-data-table
        :headers="tableHeaders"
        @click:row="goToTraining"
        item-key="id"
        :items="trainingList"
        :show-select="false"
        :disable-pagination="true"
        :hide-default-footer="true"
      >
        <template v-slot:item.showInWeb="{ item }">
          <v-icon v-show="item.showInWeb" color="var(--app-green-1)"
            >mdi-check-circle</v-icon
          >
        </template>
        <template v-slot:item.showInApp="{ item }">
          <v-icon v-show="item.showInApp" color="var(--app-green-1)"
            >mdi-check-circle</v-icon
          >
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getListTrainings();
  },
  data: () => ({
    loading: false,
    trainingList: null,
    showInfo: false,
    tableHeaders: [
      {
        text: "Название",
        sortable: false,
        value: "name",
        width: "23%",
      },
      {
        text: "Ссылка",
        sortable: false,
        value: "title",
        width: "23%",
      },
      {
        text: "Видимость WEB",
        sortable: false,
        value: "showInWeb",
        width: "10%",
      },
      {
        text: "Видимость Приложение",
        sortable: false,
        value: "showInApp",
        width: "10%",
      },
    ],
  }),
  methods: {
    goToTraining(item) {
      this.$router.push({ name: "Training", params: { id: item.id } });
    },
    goToAddTraining() {
      this.$router.push({ name: "Training" });
    },
    getListTrainings() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + "/training", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        })
        .then((res) => {
          this.trainingList = res.data;
          this.loading = true;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
};
</script>

<style lang="scss"></style>
